/**
 * UX Sprint 2 — Reusable summary card used inside composite workspaces.
 *
 * Premium dark studio card: title row + readiness pill + body slot +
 * footer "Open →" link. Used by Campaign Strategy, Visual Bible, and
 * Presentation & Delivery composite overviews.
 */
import { ArrowRight } from "lucide-react";
import ReadinessPill from "./ReadinessPill";

export default function StageSummaryCard({
    title, subtitle, status = "not_started", testid,
    children, openLabel = "Open", onOpen,
}) {
    return (
        <div
            data-testid={testid}
            className="group border border-zinc-800 rounded-sm bg-[#0a0a0a] hover:border-zinc-700 transition-colors flex flex-col"
        >
            <div className="px-5 pt-4 pb-3 border-b border-zinc-900/80 flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <div className="font-display text-base tracking-tight text-white">{title}</div>
                    {subtitle && (
                        <div className="text-[11px] text-zinc-500 mt-1 line-clamp-2">{subtitle}</div>
                    )}
                </div>
                <ReadinessPill status={status} testid={testid ? `${testid}-status` : undefined} />
            </div>
            {children && (
                <div className="px-5 py-4 text-sm text-zinc-400 flex-1">
                    {children}
                </div>
            )}
            {onOpen && (
                <button
                    type="button"
                    onClick={onOpen}
                    data-testid={testid ? `${testid}-open` : undefined}
                    className="px-5 py-3 border-t border-zinc-900/80 flex items-center justify-between text-xs font-mono uppercase tracking-wider text-zinc-400 hover:text-[#FF4400] hover:bg-zinc-900/30 transition-colors"
                >
                    <span>{openLabel}</span>
                    <ArrowRight className="w-3.5 h-3.5" />
                </button>
            )}
        </div>
    );
}
